import React from 'react'

import clsx from 'clsx'

import { FixedImage } from 'components/NextImage'
import Typography from 'components/Typography'

import styles from './EmptyState.module.scss'

/** @type {import("./types").default} */
const EmptyState = ({ img, text, variant = 'large' }) => {
  const isLarge = variant === 'large'

  return (
    <div className={clsx('EmptyState', styles[variant], styles.root)}>
      <div className={styles.imgContainer}>
        <FixedImage
          className={styles.img}
          src={img}
          alt={`Empty state illustration for "${text}"`}
          height={isLarge ? 40 : 32}
          width={isLarge ? 40 : 32}
        />
      </div>
      <Typography variant={isLarge ? 'body-sm' : 'body-xs'}>{text}</Typography>
    </div>
  )
}

export default EmptyState
